import { OrderPayment, OrderPaymentStatus } from '@oolio-group/domain';
import { sumDecimals } from '@oolio-group/order-helper';

export const sumPaymentSurcharge = (payments?: OrderPayment[]): number => {
  const byId = new Map<string, OrderPayment>();
  (payments ?? []).forEach(payment => {
    if (payment.status === OrderPaymentStatus.COMPLETE) {
      byId.set(payment.id, payment);
    }
  });
  return sumDecimals(
    [...byId.values()].map(payment => Number(payment.paymentSurcharge ?? 0)),
  );
};
